// extracted by mini-css-extract-plugin
module.exports = {"headline":"styles_headline__3l_qy","label":"styles_label__jJF3H","caption":"styles_caption__m4yKp","description":"styles_description__UsUaS","content":"styles_content__u9ol6"};